import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, withKeys as _withKeys, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/img/hxzg_logo.png';
import _imports_1 from '@/assets/img/icon.png';
const _hoisted_1 = {
  class: "login-form"
};
const _hoisted_2 = {
  class: "logo-box logo-right"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {
    "height": "40px"
  },
  alt: ""
}, null, -1);
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  style: {
    "display": "none"
  }
}, "华夏之光未来栋梁系统", -1);
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", {
  href: "/"
}, "中和黄埔官网", -1);
const _hoisted_6 = {
  class: "login-box"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  key: 0,
  class: "login-input"
};
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {
    "width": "62px",
    "margin-bottom": "9px"
  },
  alt: ""
}, null, -1);
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "欢迎登录", -1);
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", {
  class: "desc"
}, "华夏之光未来栋梁系统", -1);
const _hoisted_12 = {
  key: 1,
  class: "login-input"
};
const _hoisted_13 = {
  class: "login-back-local"
};
const _hoisted_14 = {
  class: "title"
};
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "position": "absolute",
    "right": "0",
    "bottom": "0",
    "left": "0",
    "height": "44px",
    "font-size": "14px",
    "color": "#666",
    "background-color": "#f7fafe"
  }
}, [/*#__PURE__*/_createElementVNode("p", {
  style: {
    "text-align": "center",
    "line-height": "44px"
  }
}, [/*#__PURE__*/_createTextVNode(" Copyright © 2017 北京中和黄埔教育科技有限公司 版权所有 "), /*#__PURE__*/_createElementVNode("a", {
  href: "http://www.beian.miit.gov.cn"
}, "京ICP备10217101号"), /*#__PURE__*/_createTextVNode(" 京公安网备案1070691号 ")])], -1);
import { useRouter } from 'vue-router';
// import bkImg from '@/assets/img/login_icon2.png';
import bkImg1 from '@/assets/img/hxzg_bg1.png';
import { encrypt, setToken, treeDataTranslate } from '@/common/utils/index';
import { useLoginStore, useLayoutStore } from '@/store';
import LoginController from '@/api/system/LoginController';
import OAuthController from '@/api/system/OAuthController';
import DinkTalkLogin from '@/components/DingTalk/login.vue';
import FeishuLogin from '@/components/Feishu/login.vue';
import WeWorkLogin from '@/components/WeWork/login.vue';
import WeChatLogin from '@/components/WeChat/login.vue';

import { ref, reactive, computed } from 'vue';
const __default__ = {
  name: 'LoginAdmin'
};
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    const loginForm = ref();
    const loginStore = useLoginStore();
    const layoutStore = useLayoutStore();
    const router = useRouter();
    const dataForm = reactive({
      mobilePhone: '',
      password: ''
    });
    // mobilePhone: 'admin',
    // password: '123456',
    const dataRule = {
      mobilePhone: [{
        required: true,
        message: '帐号不能为空',
        trigger: 'blur'
      }],
      password: [{
        required: true,
        message: '密码不能为空',
        trigger: 'blur'
      }]
    };
    const thirdLogin = ref({
      // 第三方登录类型, local-本地，dingtalk-钉钉 feishu-飞书 wework-企业微信 wechat-微信（关注公众号）
      loginType: 'local',
      // oauth授权成功，但是未找到绑定的账号时，生成该token
      thirdLoginToken: null
    });
    const thirdLoginComponent = computed(() => {
      switch (thirdLogin.value.loginType) {
        case 'dingtalk':
          return DinkTalkLogin;
        case 'feishu':
          return FeishuLogin;
        case 'wework':
          return WeWorkLogin;
        case 'wechat':
          return WeChatLogin;
        default:
          return 'div';
      }
    });
    const thirdLoginTitle = computed(() => {
      switch (thirdLogin.value.loginType) {
        case 'dingtalk':
          return '钉钉';
        case 'feishu':
          return '飞书';
        case 'wework':
          return '企业微信';
        case 'wechat':
          return '微信';
        default:
          return '';
      }
    });
    const onThirdLoginClick = type => {
      thirdLogin.value.loginType = type;
    };
    const handleOAuthSuccess = data => {
      console.log('第三方登录成功', data);
      layoutStore.setMenuList(treeDataTranslate(data.data.menuList, 'menuId', 'parentId'));
      delete data.data.menuList;
      loginStore.setUserInfo(data.data);
      setToken(data.data.tokenData);
      layoutStore.setCurrentMenu(null);
      router.replace({
        name: 'main'
      });
    };
    const handleOAuthError = err => {
      console.error('第三方登录失败', err);
      if (err && err.errorCode === 'DATA_NOT_EXIST') {
        thirdLogin.value.thirdLoginToken = err.data.token;
        onThirdLoginClick('local');
      }
    };
    const loginAndBind = params => {
      params.token = thirdLogin.value.thirdLoginToken;
      thirdLogin.value.thirdLoginToken = null;
      OAuthController.doLoginAndBind(params, {
        showMask: false
      }).then(data => {
        layoutStore.setMenuList(treeDataTranslate(data.data.menuList, 'menuId', 'parentId'));
        delete data.data.menuList;
        loginStore.setUserInfo(data.data);
        setToken(data.data.tokenData);
        layoutStore.setCurrentMenu(null);
        router.replace({
          name: 'main'
        });
      }).catch(e => {
        console.error(e);
      });
    };
    const dataFormSubmit = () => {
      loginForm.value?.validate(valid => {
        if (valid) {
          login();
        }
      });
    };
    const login = function (verifyParams = null) {
      let params = {
        loginName: dataForm.mobilePhone,
        password: encrypt(dataForm.password),
        captchaVerification: verifyParams?.captchaVerification
      };
      setToken(null);
      LoginController.login(params).then(data => {
        //console.log('login >>>', data);
        if (data.data.menuList) {
          layoutStore.setMenuList(treeDataTranslate(data.data.menuList, 'menuId', 'parentId'));
          delete data.data.menuList;
        }
        setToken(data.data.tokenData);
        layoutStore.setCurrentMenu(null);
        layoutStore.clearAllTags();
        if (data.data.tokenData) {
          delete data.data.tokenData;
        }
        loginStore.setUserInfo(data.data);
        // 登录成功跳转页面
        router.replace({
          name: 'main'
        });
      }).catch(e => {
        console.error(e);
      });
    };
    return (_ctx, _cache) => {
      const _component_el_space = _resolveComponent("el-space");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_text = _resolveComponent("el-text");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_form = _resolveComponent("el-form");
      const _component_Back = _resolveComponent("Back");
      const _component_el_icon = _resolveComponent("el-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _hoisted_4, _createVNode(_component_el_space, {
        direction: "horizontal"
      }, {
        default: _withCtx(() => [_hoisted_5]),
        _: 1
      })]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", null, [_createElementVNode("img", {
        src: _unref(bkImg1),
        style: {
          "height": "550px",
          "width": "auto"
        }
      }, null, 8, _hoisted_7)]), _unref(thirdLogin).loginType === 'local' ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_hoisted_9, _hoisted_10, _hoisted_11, _createVNode(_component_el_form, {
        model: _unref(dataForm),
        rules: dataRule,
        "label-position": "top",
        ref_key: "loginForm",
        ref: loginForm,
        onKeyup: _withKeys(_withModifiers(() => {}, ["stop"]), ["enter"])
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 24
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "mobilePhone",
            label: "",
            style: {
              "margin-top": "48px",
              "margin-bottom": "25px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(dataForm).mobilePhone,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(dataForm).mobilePhone = $event),
              style: {
                "width": "100%"
              },
              placeholder: "请输入帐号",
              onKeydown: _withKeys(dataFormSubmit, ["enter"])
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 24
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "password",
            label: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(dataForm).password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(dataForm).password = $event),
              style: {
                "width": "100%"
              },
              type: "password",
              placeholder: "请输入密码",
              "show-password": "",
              onKeydown: _withKeys(dataFormSubmit, ["enter"])
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_button, {
          class: "login-btn-submit",
          type: "primary",
          size: "large",
          onClick: _cache[2] || (_cache[2] = $event => dataFormSubmit()),
          style: {
            "width": "100%",
            "margin-top": "48px"
          }
        }, {
          default: _withCtx(() => [_createTextVNode(" 登录 ")]),
          _: 1
        }), _createVNode(_component_el_space, {
          direction: "horizontal",
          style: {
            "justify-content": "center",
            "width": "100%",
            "margin-top": "12px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_text, {
            class: "mx-1"
          }, {
            default: _withCtx(() => [_createTextVNode("没有账号，")]),
            _: 1
          }), _createVNode(_component_el_link, {
            type: "primary",
            style: {
              "font-size": "14px"
            }
          }, {
            default: _withCtx(() => [_createTextVNode("立即注册")]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "onKeyup"])])) : (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createVNode(_component_el_icon, {
        title: "返回账号密码登录",
        style: {
          "font-size": "18px"
        },
        onClick: _cache[3] || (_cache[3] = $event => onThirdLoginClick('local'))
      }, {
        default: _withCtx(() => [_createVNode(_component_Back)]),
        _: 1
      }), _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(thirdLoginTitle)) + "登录", 1), (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(thirdLoginComponent)), {
        onSuccess: handleOAuthSuccess,
        onError: handleOAuthError
      }, null, 32))])]))]), _hoisted_15]);
    };
  }
});